'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setPositionScroll = setPositionScroll;
exports.setCarouselScroll = setCarouselScroll;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_POSITIONSCROLL = 'scroll/SET_POSITIONSCROLL';
var SET_CAROUSELSCROLL = 'scroll/SET_CAROUSELSCROLL';

var initialState = {
  positionScroll: 0,
  carouselScroll: -1
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_POSITIONSCROLL:
      return (0, _extends3.default)({}, state, {
        positionScroll: action.newState
      });
    case SET_CAROUSELSCROLL:
      return (0, _extends3.default)({}, state, {
        carouselScroll: action.newState
      });
    default:
      return state;
  }
}

function setPositionScroll(newValue) {
  return {
    type: SET_POSITIONSCROLL,
    newState: newValue
  };
}

function setCarouselScroll(newValue) {
  return {
    type: SET_CAROUSELSCROLL,
    newState: newValue
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/scroll.js
// module id = 86
// module chunks = 0